import { useCallback, useEffect, useState } from 'react';
import config from '../../temp/config';

const useRecaptcha = () => {
  const [isRecaptchaReady, setIsRecaptchaReady] = useState(false);
  const siteKey = config.recaptcha?.sitekey;
  useEffect(() => {
    if (!config.recaptcha.toggle || config.recaptcha.toggle === 'false') {
      setIsRecaptchaReady(false);
      return;
    }
    if (typeof window !== 'undefined' && window.grecaptcha) {
      setIsRecaptchaReady(true);
    } else {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?&render=${siteKey}`;
      script.async = true;
      document.head.appendChild(script);
      script.onload = () => {
        setIsRecaptchaReady(true);
      };
    }
  }, [siteKey, isRecaptchaReady]);
  const executeRecaptcha = useCallback(async action => {
    if (!config.recaptcha.toggle) {
      return '';
    }
    if (typeof window !== 'undefined' && isRecaptchaReady && window.grecaptcha) {
      return window.grecaptcha.execute(siteKey, { action });
    }
  });
  return executeRecaptcha;
};

export default useRecaptcha;
